<template>
	<div>
		<div class="stepMain">
			<div class="container">
				<h3 class="title">申请入驻人民党建云</h3>
				<router-view></router-view>
			</div>
		</div>
	</div>
</template>

<script>
	import djyLoginHeader from '../../components/djyLoginHeader/index.vue'
	import djyJoinStep from '../../components/djyJoinStep/index.vue'
	import {sessionKeepAlive} from '../../api/join'

	export default {
		name: 'index',
		components: {
			djyLoginHeader,
			djyJoinStep,
		},
		data() {
			return {
				step: 1,
				route:null,
				timer:null
			}
		},
		created() {
			console.log(this.$route.name);
			this.route = this.$route
		},
		methods:{
			watchStep() {
				const that = this
				sessionKeepAlive({
					_ajax: 1
				}).then(res => {
					console.log(res.data.wait);
					if (res.data.code == 1) {} else {
						if (that.step > 1) {
							that.$message({
								message: res.data.msg,
								type: 'warning',
								onClose: () => {
									that.$router.replace({path:'/'})
								}
							});
						}
					}
				}).catch(error => {
					console.log(error);
				})
			},
		},
		watch: {
			route(to, from) {
				// 对路由变化作出响应...
				console.log('to', to)
				console.log('from', from)
				switch (to.name) {
					case 'join_step1':
						this.step = 1;
						break;
					case 'join_step2':
						this.step = 2;
						break;
					case 'join_step3':
						this.step = 3;
						break;
					case 'join_step4':
						this.step = 4;
						break;
					default:
						break;
				}
				console.log(this.step);
				// if(this.step > 1){
				// 	this.timer =  setInterval(() => {
				// 		this.watchStep()
				// 	},60000)
				// }else{
				// 	clearInterval(this.timer)
				// }
			}
		},
		destroyed(){
			console.log('离开页面');
			clearInterval(this.timer)
		}
	}
</script>

<style lang="scss">
	@import '~@/assets/css/default.css'
</style>
